import { render, staticRenderFns } from "./sorotecageladeira.vue?vue&type=template&id=64af59e9&"
import script from "./sorotecageladeira.vue?vue&type=script&lang=js&"
export * from "./sorotecageladeira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports